import { Transfer } from 'antd';
import { Form } from '@bancobarigui/barihaus';

import { useProvidersTransfer } from './useProvidersTransfer';

export function ProvidersTransfer() {
  const { providers } = useProvidersTransfer();

  return (
    <>
      <style>{`
        .providers-transfer .ant-transfer-list {
          border-radius: 8px !important;
          border-color: #d6dbe7 !important;
        }
        .providers-transfer .ant-transfer-list-search .ant-input,
        .providers-transfer .ant-transfer-list-search.ant-input-affix-wrapper {
          border-radius: 8px !important;
          border-color: #d6dbe7 !important;
        }
      `}</style>
      <Form.Item
        name="providerIds"
        valuePropName="targetKeys"
        getValueFromEvent={(targetKeys) => targetKeys}
        rules={[
          { required: true, message: 'Informe uma provedora.' },
          {
            type: 'array',
            max: 1,
            message: 'Você só pode selecionar no máximo 1 Prestadora.',
          },
        ]}
      >
        <Transfer
          className="providers-transfer"
          listStyle={{
            width: '50%',
            height: 300,
          }}
          dataSource={providers}
          showSelectAll={false}
          render={(item) => item.title ?? ''}
          titles={['Prestadoras Disponíveis', 'Prestadoras Selecionadas']}
        />
      </Form.Item>
    </>
  );
}
